import { createGraphQLClient } from '@shopify/graphql-client';
import { getBuyer, clearBuyer, isBuyerSettled, whenBuyerReady } from './buyerContext';

const Domain = `https://${window.domain}.myshopify.com/api/2026-04/graphql.json`;
const storefrontToken = window.storefrontToken;

class Storefront {
  constructor() {
    this.client = new createGraphQLClient({
      url: Domain,
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      retries: 1
    });
  }

  async request(query, options) {
    if (!isBuyerSettled()) {
      await whenBuyerReady();
    }
    const buyer = getBuyer();
    let merged = options;
    if (buyer) {
      const isOptionsObject = options && typeof options === 'object' && !Array.isArray(options) && 'variables' in options;
      if (isOptionsObject) {
        merged = { ...options, variables: { ...(options.variables || {}), buyer } };
      } else {
        merged = { ...(options || {}), buyer };
      }
    }
    let result = await this.client.request(query, merged);
    const graphQLErrors = result?.errors?.graphQLErrors || [];
    if (buyer && graphQLErrors.some(err => String(err?.message || '').includes('not valid'))) {
      try {
        sessionStorage.removeItem('cap.token');
      } catch (err) {
        void err;
      }
      clearBuyer();
      result = await this.client.request(query, options);
    }
    return result;
  }
}

export default new Storefront();
